import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { Banners } from '@/components/layout';
import useChatWidgetFullscreenActive from '../../hooks/use-chat-widget-fullscreen-active';
import { useChatWidgetSlot } from './chat-widget-slot-context';

// Overlays the content card (absolute, anchored to the card's `relative`) when the chat
// is fullscreen: the assume banner sits on top, the chat host portals into the flex-1
// region below it. Always mounted (only the class toggles) so the ref registration is
// stable and fullscreenSlotEl is non-null the instant the presentation flips — the morph
// then measures the correct final rect. The banner is gated on `active` so its height-
// tracking effect can't write --assume-banner-height: 0 while display:none and fight the
// layout's banner, which keeps rendering underneath (suppressing it would collapse its
// height mid-morph and jump the page up), so this one sits on top.
// Opaque as soon as it activates: the page behind reflows the moment the docked column is given
// up, and that must not show. On a phone nothing reflows, so it stays clear for the chat to slide
// up over the page; there it anchors to the app shell (the card isn't positioned), so it covers
// the top bar too and clips the sliding sheet.
// No padding/border/rounding here: the content card + the host supply those.
const ChatWidgetFullscreenSlot = () => {
  const $ = _c(11);
  const {
    setFullscreenSlotEl
  } = useChatWidgetSlot();
  const active = useChatWidgetFullscreenActive();
  const t0 = active ? "absolute flex flex-col md:bg-primary max-md:top-[env(safe-area-inset-top)] max-md:overflow-hidden" : "hidden";
  let t1;
  if ($[0] !== t0) {
    t1 = cx("inset-0 z-20", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== active) {
    t2 = active && <Banners hideEnvironmentBanner={true} />;
    $[2] = active;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !active;
  let t4;
  if ($[4] !== setFullscreenSlotEl || $[5] !== t3) {
    t4 = <div ref={setFullscreenSlotEl} className="flex-1 min-h-0" aria-hidden={t3} />;
    $[4] = setFullscreenSlotEl;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default ChatWidgetFullscreenSlot;